<template>
    <div ref="editor"></div>
</template>
<script>
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";

export default {
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        placeholderSend: {
            type: String,
            default: "",
        },

    },
    data() {
        return {
            editor: null,
            placeholder: this.$props.placeholderSend
        };
    },
    mounted() {
        var _this = this;

        this.editor = new Quill(this.$refs.editor, {
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],
                    ['link', 'formula'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],

                    ['clean']                                         // remove formatting button
                ],
            },
            //theme: 'bubble',
            theme: "snow",
           
            placeholder: this.placeholder,
        });
        this.editor.colors = [{ 'color': ['#e60000', '#9933ff', '#00ff00'] }];


        this.editor.root.innerHTML = this.modelValue;
        this.editor.on("text-change", function () {
            return _this.updateText();
        });
    },

    methods: {
        updateText() {
            this.$emit("update-text", this.editor.getText() ? this.editor.root.innerHTML : "");
        },
        updateTextEditor(text) {
            this.editor.root.innerHTML = text;
        }

    },
};
</script>
<style>
.ql-editor {
    height: 180px;
    overflow: auto;
    color:#000;
    border: 1px solid #000000;
}

.ql-snow .ql-tooltip {
    z-index: 1;
    position: absolute;
}
</style>